var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBody1Back(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1146.39 728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-body-1 {\n        fill: #d61800;\n      }\n\n      .cls-body-2 {\n        fill: var(--custom-color, #fa) !important;\n      }\n\n      .cls-body-3 {\n        fill: #fff;\n      }\n\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M382.52,128.11l-77.87-53.53-163.54,237.9c-10.91-3.78-22.61-5.86-34.8-5.86-58.71,0-106.31,47.6-106.31,106.31s47.6,106.31,106.31,106.31,106.31-47.6,106.31-106.31c0-10.78-1.62-21.18-4.6-30.98l174.5-253.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M763.87,128.11l77.87-53.53,163.54,237.9c10.91-3.78,22.61-5.86,34.8-5.86,58.71,0,106.31,47.6,106.31,106.31,0,58.71-47.6,106.31-106.31,106.31-58.71,0-106.31-47.6-106.31-106.31,0-10.78,1.62-21.18,4.6-30.98l-174.5-253.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M984.65,281.33c-1.39.12-2.76.21-4.13.29-51.68,3.02-98.37-30.87-112.99-80.53l-46.58-158.28h-480.37v.5l-46.53,157.21c-14.69,49.63-61.38,83.46-113.04,80.44-1.36-.08-2.74-.18-4.13-.29l-2.45,26.64c-1.39,15.19-1.03,30.48,1.1,45.58h0c14.36,101.58,95.27,188.28,209.47,235.2,33.07,13.59,68.95,23.78,106.8,30.1,2.94.51,5.86.99,8.77,1.44,25.93,3.87,52.74,5.92,80.19,5.92,213.3,0,388.3-122.71,406.02-279,0-.09.02-.17.03-.26,1.48-13.21,1.42-26.55.18-39.79l-2.35-25.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M308.14,237.36c27.58-12.05,54.99-36.9,74.74-70.84,36.86-63.33,33.08-134.25-8.43-158.42-41.52-24.16-105.05,7.58-141.91,70.91-19.75,33.93-27.82,70.04-24.68,99.98l100.29,58.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M827.03,237.36c-27.58-12.05-54.99-36.9-74.74-70.84-36.86-63.33-33.08-134.25,8.43-158.42,41.52-24.16,105.05,7.58,141.91,70.91,19.75,33.93,27.82,70.04,24.68,99.98l-100.29,58.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 408.06,
    cy: 638.4,
    rx: 97.45,
    ry: 76.07,
    transform: "translate(-154.6 130.97) rotate(-15.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-3",
    cx: 404.12,
    cy: 650.21,
    rx: 97.45,
    ry: 76.07,
    transform: "translate(-157.87 130.35) rotate(-15.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 725.02,
    cy: 638.4,
    rx: 76.07,
    ry: 97.45,
    transform: "translate(-82.7 1168.31) rotate(-74.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-3",
    cx: 728.96,
    cy: 650.21,
    rx: 76.07,
    ry: 97.45,
    transform: "translate(-91.19 1180.79) rotate(-74.63)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody1Back);
export default __webpack_public_path__ + "static/media/body1-back.def30c300ab004d3dc026a4c1400eaec.svg";
export { ForwardRef as ReactComponent };